/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description answerAnswerIdAdoptUsingPost参数
 * @property `answerId` 回答ID
 * @property `isAdopt` true:采纳 false:取消
 */
export interface ParamsanswerAnswerIdAdoptUsingPost {
  // pathParams
  /**
   * 回答ID
   */
  answerId: number;
  // queryParams
  /**
   * true:采纳 false:取消
   */
  isAdopt: boolean;
}
/**
 * @description answerAnswerIdAgreeUsingPost参数
 * @property `answerId` 回答ID
 * @property `type` 类型 0取消 1赞同 2反对
 */
export interface ParamsanswerAnswerIdAgreeUsingPost {
  // pathParams
  /**
   * 回答ID
   */
  answerId: number;
  // queryParams
  /**
   * 类型 0取消 1赞同 2反对
   */
  type: number;
}
/**
 * @description answerAnswerIdEditUsingGet参数
 * @property `answerId` 回答ID
 * @property `status` 回答状态 DRAFT草稿 PUBLISHED_EDI被回复人为空T已发布
 */
export interface ParamsanswerAnswerIdEditUsingGet {
  // pathParams
  /**
   * 回答ID
   */
  answerId: number;
  // queryParams
  /**
   * 回答状态 DRAFT草稿 PUBLISHED_EDI被回复人为空T已发布
   */
  status: string;
}
/**
 * @description answerAnswerIdRevokeUsingPost参数
 * @property `answerId` 回答ID
 */
export interface ParamsanswerAnswerIdRevokeUsingPost {
  // pathParams
  /**
   * 回答ID
   */
  answerId: number;
}
/**
 * @description answerAnswerIdUsingDelete参数
 * @property `answerId` 回答ID
 * @property `type` 状态 DRAFT草稿 PUBLISHED_EDIT已发布
 */
export interface ParamsanswerAnswerIdUsingDelete {
  // pathParams
  /**
   * 回答ID
   */
  answerId: number;
  // queryParams
  /**
   * 状态 DRAFT草稿 PUBLISHED_EDIT已发布
   */
  type: string;
}
/**
 * @description answerCommentAnswerIdUsingGet参数
 * @property `answerId` 回答ID
 * @property `[orderBy]` 排序方式, 0正序-最早优先 1倒序-最新优先
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsanswerCommentAnswerIdUsingGet {
  // pathParams
  /**
   * 回答ID
   */
  answerId: number;
  // queryParams
  /**
   * 排序方式, 0正序-最早优先 1倒序-最新优先
   */
  orderBy?: number;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * answerCommentVO
 */
export type ParamsBodyanswerCommentUsingPost = models.AnswerCommentVO;
/**
 * @description answerDraftUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 * @property `[type]` 列表类型 1提问草稿 2提问发布 3回答草稿 4回答发布
 */
export interface ParamsanswerDraftUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
  /**
   * 列表类型 1提问草稿 2提问发布 3回答草稿 4回答发布
   */
  type?: number;
}
/**
 * @description answerIdAnswerIdUsingGet参数
 * @property `answerId` 回答ID
 */
export interface ParamsanswerIdAnswerIdUsingGet {
  // pathParams
  /**
   * 回答ID
   */
  answerId: number;
}
/**
 * answer
 */
export type ParamsBodyanswerPublishUsingPost = models.AnswerVO;
/**
 * @description answerQuestionIdCheckUsingGet参数
 * @property `questionId` 问题ID
 */
export interface ParamsanswerQuestionIdCheckUsingGet {
  // pathParams
  /**
   * 问题ID
   */
  questionId: number;
}
/**
 * @description answerQuestionIdUsingGet参数
 * @property `questionId` 问题ID
 * @property `[orderBy]` 排序方式, 0默认 1更新时间
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsanswerQuestionIdUsingGet {
  // pathParams
  /**
   * 问题ID
   */
  questionId: number;
  // queryParams
  /**
   * 排序方式, 0默认 1更新时间
   */
  orderBy?: number;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * answerDraftVO
 */
export type ParamsBodyanswerSaveUsingPost = models.AnswerEditInfo;
export class AnswerApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   *
   * @summary 采纳回答（只有作者本人）
   * @param params ParamsanswerAnswerIdAdoptUsingPost

   * @param opt ajax config
   * @returns models.CommonResult
   */
  public answerAnswerIdAdoptUsingPost = (
    params: ParamsanswerAnswerIdAdoptUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/answer/{answerId}/adopt';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('isAdopt' in params) p.query.isAdopt = params.isAdopt;
    ajax.check(params.isAdopt, 'isAdopt');
    ajax.check(params.answerId, 'answerId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 赞同/反对回答 或 取消赞同/反对
   * @param params ParamsanswerAnswerIdAgreeUsingPost

   * @param opt ajax config
   * @returns models.CommonResultAnswerAgreeCount
   */
  public answerAnswerIdAgreeUsingPost = (
    params: ParamsanswerAnswerIdAgreeUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultAnswerAgreeCount> => {
    const path = '/api/answer/{answerId}/agree';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    ajax.check(params.answerId, 'answerId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 从草稿箱进入编辑页面获取内容
   * @param params ParamsanswerAnswerIdEditUsingGet

   * @param opt ajax config
   * @returns models.CommonResultanswerVO
   */
  public answerAnswerIdEditUsingGet = (
    params: ParamsanswerAnswerIdEditUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultanswerVO> => {
    const path = '/api/answer/{answerId}/edit';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('status' in params) p.query.status = params.status;
    ajax.check(params.status, 'status');
    ajax.check(params.answerId, 'answerId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 将草稿回溯到最新发布的版本
   * @param params ParamsanswerAnswerIdRevokeUsingPost

   * @param opt ajax config
   * @returns models.CommonResultAnswerEditInfo
   */
  public answerAnswerIdRevokeUsingPost = (
    params: ParamsanswerAnswerIdRevokeUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultAnswerEditInfo> => {
    const path = '/api/answer/{answerId}/revoke';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.answerId, 'answerId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 删除回答
   * @param params ParamsanswerAnswerIdUsingDelete

   * @param opt ajax config
   * @returns models.CommonResult
   */
  public answerAnswerIdUsingDelete = (
    params: ParamsanswerAnswerIdUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/answer/{answerId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    ajax.check(params.answerId, 'answerId');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 获取评论
   * @param params ParamsanswerCommentAnswerIdUsingGet

   * @param opt ajax config
   * @returns models.CommonResultListCommentInfo
   */
  public answerCommentAnswerIdUsingGet = (
    params: ParamsanswerCommentAnswerIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListCommentInfo> => {
    const path = '/api/answer/comment/{answerId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('orderBy' in params) p.query.orderBy = params.orderBy;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.answerId, 'answerId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 评论

   * @param data: ParamsBodyanswerCommentUsingPost// answerCommentVO
   * @param opt ajax config
   * @returns models.CommonResultCommentInfo
   */
  public answerCommentUsingPost = (
    data: ParamsBodyanswerCommentUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultCommentInfo> => {
    const path = '/api/answer/comment';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.answerCommentVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 我的草稿——问答列表
   * @param params ParamsanswerDraftUsingGet

   * @param opt ajax config
   * @returns models.CommonResultPageableResult
   */
  public answerDraftUsingGet = (
    params: ParamsanswerDraftUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResult> => {
    const path = '/api/answer/draft';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('type' in params) p.query.type = params.type;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 单独浏览某条回答时的回答详情
   * @param params ParamsanswerIdAnswerIdUsingGet

   * @param opt ajax config
   * @returns models.CommonResultAnswerInfo
   */
  public answerIdAnswerIdUsingGet = (
    params: ParamsanswerIdAnswerIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultAnswerInfo> => {
    const path = '/api/answer/id/{answerId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.answerId, 'answerId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 发布回答

   * @param data: ParamsBodyanswerPublishUsingPost// answer
   * @param opt ajax config
   * @returns models.CommonResultanswerVO
   */
  public answerPublishUsingPost = (
    data: ParamsBodyanswerPublishUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultanswerVO> => {
    const path = '/api/answer/publish';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.answer');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 判断是否回答过
   * @param params ParamsanswerQuestionIdCheckUsingGet

   * @param opt ajax config
   * @returns models.CommonResultAnswerEditInfo
   */
  public answerQuestionIdCheckUsingGet = (
    params: ParamsanswerQuestionIdCheckUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultAnswerEditInfo> => {
    const path = '/api/answer/{questionId}/check';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.questionId, 'questionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 根据问题id分页获取回答
   * @param params ParamsanswerQuestionIdUsingGet

   * @param opt ajax config
   * @returns models.CommonResultPageableResultAnswerInfo
   */
  public answerQuestionIdUsingGet = (
    params: ParamsanswerQuestionIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultAnswerInfo> => {
    const path = '/api/answer/{questionId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('orderBy' in params) p.query.orderBy = params.orderBy;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.questionId, 'questionId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 保存回答草稿

   * @param data: ParamsBodyanswerSaveUsingPost// answerDraftVO
   * @param opt ajax config
   * @returns models.CommonResultAnswerEditInfo
   */
  public answerSaveUsingPost = (
    data: ParamsBodyanswerSaveUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultAnswerEditInfo> => {
    const path = '/api/answer/save';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.answerDraftVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new AnswerApi();
